export const LOAD_COUNTRY = 'event-widgets/country/LOAD_COUNTRY';

// Blank option is added after getting the response from the service
const blankCountryData = {
  code: '',
  sort: 999,
  name: '',
  nameResourceKey: '',
  isoCode: 0,
  requireZipCodeFlag: false,
  metroAreaGroupId: 0,
  id: 0,
  alphaThreeCode: ''
};

/*
 * Creates a thunked action to load the countries from the lookup.
 */
export function createLoadCountry(registerTranslation, localizationContext = undefined) {
  return async (dispatch, getState) => {
    const { accessToken, text, countries: loadedCountries,
      clients: { lookupClient } } = getState();
    let locale = localizationContext ? localizationContext.locale : text.locale;
    let translate = localizationContext ? localizationContext.translate : text.translate;

    if (loadedCountries && loadedCountries.locale === locale && Object.keys(loadedCountries.countries).length > 0) {
      return;
    }
    const countriesLookupResponse = await lookupClient.getCountries(accessToken, locale);
    const translations = countriesLookupResponse.translations;
    for (const translationLocale in translations) {
      if (translations.hasOwnProperty(translationLocale)) {
        dispatch(registerTranslation(translations[translationLocale], translationLocale));
      }
    }
    const countriesResponse = countriesLookupResponse.countries;
    let sortedCountries = {};
    // Inserting blank entry to country list and sorting it by name
    sortedCountries[''] = blankCountryData;
    Object.keys(countriesResponse).sort((a, b) => {
      return translate(countriesResponse[a].nameResourceKey).localeCompare(
        translate(countriesResponse[b].nameResourceKey));
    }).forEach(code => {
      sortedCountries[code] = countriesResponse[code];
    });
    const countries = {
      countries: sortedCountries,
      locale
    };
    dispatch({ type: LOAD_COUNTRY, payload: { countries } });
  };
}

export default function reducer(state, action) {
  switch (action.type) {
    case LOAD_COUNTRY:
      return action.payload.countries;
    default:
      return state;
  }
}
